import { useInfiniteQuery } from "@tanstack/react-query";

import { notificationPageQueryOptions } from "./notificationPageQueryOptions";
import type { NotificationFilters } from "../types";

export function useNotificationsPage(filters: NotificationFilters) {
  return useInfiniteQuery(notificationPageQueryOptions(filters));
}
